import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/facturacion/facturas';
import Facturas from './SaldosIniciales';


const ms2p = (state) => {
  return {
    ...state.factura,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Facturas);
